import { render, staticRenderFns } from "./ProfileCompanyForm.vue?vue&type=template&id=898546ea&"
import script from "./ProfileCompanyForm.vue?vue&type=script&lang=js&"
export * from "./ProfileCompanyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports